// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectMassChannelCustomerFollowupDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_MASS_CHANNEL_CUSTOMER_FOLLOWUP_DEALER
});

export const selectAllMassChannelCustomerFollowupDealers = dealers => ({
    dealers,
    type: actions.SELECT_ALL_MASS_CHANNEL_CUSTOMER_FOLLOWUP_DEALERS
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_MASS_CHANNEL_CUSTOMER_FOLLOWUP_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/action-creators/select-dealer.js